import { render, staticRenderFns } from "./AcuteBotanyHost.vue?vue&type=template&id=47f358a5&scoped=true"
import script from "./AcuteBotanyHost.vue?vue&type=script&lang=js"
export * from "./AcuteBotanyHost.vue?vue&type=script&lang=js"
import style0 from "./AcuteBotanyHost.vue?vue&type=style&index=0&id=47f358a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f358a5",
  null
  
)

export default component.exports